import settings from "../../constants/settings";
import { sendGTMEvent } from "@next/third-parties/google";
import { useAppSelector } from "../hooks/store";
import { useCallback } from "react";
import { useSendError } from "./logging";

export const G_TAG_ID = "GTM-PGRGZTG2";

export const PURCHASE_EVENT = "Place order";
export const NEWSLETTER_SIGNUP_EVENT = "Sign-up for newsletter";
export const UPLOAD_BOARD_EVENT = "Upload board";
export const POPULATE_BOARD_EVENT = "Populate board";
export const CUSTOMER_IS_A_PROFESSIONAL = "Customer is a professional";
export const FILL_OUT_CONTACT_US_FORM = "Fill out contact us form";
export const UPLOAD_GERBERS_EVENT = "Upload Gerbers";
interface GoogleEvent {
  action: string;
  parameters?: { [key: string]: string | number | undefined };
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export default function useTrackGoogleEvent() {
  const sendError = useSendError();
  const { email } = useAppSelector((state) => state.auth);

  return useCallback(
    ({ action, parameters }: GoogleEvent) => {
      if (
        settings.google_analytics_enabled &&
        !email?.endsWith("@flashpcb.com")
      ) {
        try {
          sendGTMEvent({ event: action, ...parameters });
        } catch (e) {
          sendError(e);
        }
      }
    },
    [email, sendError],
  );
}
